import MainPageAnalise from '@/screens/analise/MainPage'
import { items } from '@/screens/analise/config'

const analise = [
  {
    path: '/analise',
    name: 'analise',
    component: MainPageAnalise,
    meta: {
      isPublic: false
    },
    children: [...items]
  }
]

export default analise



// WEBPACK FOOTER //
// ./src/router/analise.js